import { ReduxState } from "../types/main-reducer-types";

export const getUserInfo = (state: ReduxState) => state.user.info;

export const getAuthenticationStatus = (state: ReduxState) =>
  state.auth.isAuthenticated;

export const getAdminInfo = (state: ReduxState) => state.user.adminInfo;
